import { BooleanField, ListBase } from "react-admin";
import { useListContext } from "react-admin";

import { DataKind, Resource } from "../../types";
import { CustomDateTimeField, CustomList } from "../custom";

const MaintenanceList = () => {
  const max_expected_maintenance_windows = 1;
  const { data } = useListContext();

  return (
    <CustomList
      checkPermissionFor={DataKind.OtcMaintenanceWindow}
      displayCreate={data?.length < max_expected_maintenance_windows}
    >
      <CustomDateTimeField label="Start Time" source="start_time" />
      <BooleanField label="Completed" source="completed" />

      <CustomDateTimeField label="Created At" source="created_at" />
      <CustomDateTimeField label="Updated At" source="updated_at" />
    </CustomList>
  );
};

function OtcMaintenanceWindowList() {
  return (
    // Using ListBase here to be able to use useListContext in MaintenanceList
    <ListBase resource={Resource.OtcMaintenanceWindow}>
      <MaintenanceList />
    </ListBase>
  );
}

export default OtcMaintenanceWindowList;
